import React, { type PropsWithChildren } from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function FeatureModalContainer({ children, icon }: PropsWithChildren & { icon: IconProp }) {
  return (
    <div className="relative mb-3 flex w-full flex-col items-center justify-center gap-y-4">
      <div className="silver-holographic rounded-full p-1">
        <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-black">
          <FontAwesomeIcon icon={icon} fontSize="24px" className="text-silver" />
        </div>
      </div>

      {children}
    </div>
  );
}
